import { Action } from '@ngrx/store';
import {LicenseMgtListFilterActions, ListFilterActionTypes} from '../actions/license-mgt-list-filter.actions';


export interface State {
  RegionIdOptions: number;
  RegionMgtIdOptions: number;
  UsingStatusOptions: number;
  LicenseTypeOptions: number;
  RemainDaysOptions: number;
}

export const initialState: State = {
  RegionIdOptions: -1,
  RegionMgtIdOptions: -1,
  UsingStatusOptions: -1,
  LicenseTypeOptions: -1,
  RemainDaysOptions: -1
};

export function reducer(state = initialState, action: LicenseMgtListFilterActions): State {
  switch (action.type) {
    case ListFilterActionTypes.SelectLicenseListFilters:
      return {...state,
      RegionIdOptions: action.payload.RegionId,
      RegionMgtIdOptions: action.payload.RegionMgtId,
      UsingStatusOptions: action.payload.UsingStatus,
      LicenseTypeOptions: action.payload.LicenseType,
      RemainDaysOptions: action.payload.RemainDays};
    default:
      return state;
  }
}
